import { render, staticRenderFns } from "./MHarga.vue?vue&type=template&id=33c9f4e2&"
import script from "./MHarga.vue?vue&type=script&lang=js&"
export * from "./MHarga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports